export default __webpack_public_path__ + "static/media/s-topicicon.b952e4a4.svg";